module.exports = __webpack_public_path__ + "vue/img/ai-error.88487237.jpg";